<template>
  <div>

    <b-field label="Name">
      <b-input v-model="name" :required="true" ref="autofocus"></b-input>
    </b-field>

    <b-field label="Beschreibung">
      <b-input type="textarea" v-model="comment" placeholder="Optional"></b-input>
    </b-field>

    <div class="field">
      <b-checkbox v-model="keepValues">
        Aktuelle Werte übernehmen
      </b-checkbox>
    </div>

    <div class="field">
      <b-checkbox v-model="isDefault">
        Als Standard-Variante festlegen
      </b-checkbox>
    </div>

    <div :style="{'text-align': 'right'}">
      <button type="button" class="button is-success" :disabled="!name.length" @click="onConfirm">OK</button>
      <button type="button" class="button is-danger" @click="closeModals">Abbrechen</button>
    </div>

  </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from 'vuex'
import { closeModals } from '@/store/modules/modals'
import { addVariant } from '@/store/modules/variants'
import modals from '@/mixins/modals'

export default {
  name: 'ima-variant-modal',
  data () {
    return {
      name: '',
      comment: '',
      keepValues: true,
      isDefault: false
    }
  },
  mixins: [modals],
  computed: {
    ...mapState(['sign', 'variant', 'labels'])
  },
  methods: {
    ...mapActions([addVariant]),
    ...mapMutations([closeModals]),
    onConfirm () {
      this.addVariant({
        ...this.variant.data,
        labels: this.keepValues
          ? this.labels.data.map(({ name, value }) => ({ name, value }))
          : [],
        signId: this.sign.data.id,
        name: this.name,
        comment: this.comment,
        isDefault: this.isDefault
      }).then(() => {
        this.closeModals()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/VariantModal.vue